import React from "react";
import { Link } from "react-router-dom";
import ROUTES from "../../utils/routes";
import { LazyLoadImage } from "react-lazy-load-image-component";

import {
  convertToPrice as getPrecio,
  encodeNumber as nToString,
} from "../../API/request";

const MiniaturaItem = ({ item, showPrice, catSelect }) => {
  return (
    <div className="col galeria__item">
      <div className="galeria__item--article">
        <Link to={ROUTES.DETAILSEMPTY + nToString(item.id)}>
          <div className="galeria__item--article--image">
            <LazyLoadImage
              alt={item.img}
              src={process.env.REACT_APP_IMAGE_ARTICLES_PATH + item.img}
            />
          </div>
        </Link>
        <hr className="galeria__item--article--hr col-10 offset-1 col-md-8 offset-md-2 col-xl-6 offset-xl-3" />
        <div className="galeria__item--article--info">
          <span className="galeria__item--article--info--name">
            {item.nombre}
          </span>
          <div className="galeria__item--article--info--detail">
            {showPrice && <span>{getPrecio(item.precioPublico)}</span>}
            <Link to={ROUTES.DETAILSEMPTY + nToString(item.id)}>
              <u>Ver detalles</u>
            </Link>
          </div>
        </div>
        <div className="galeria__item--article--link ">
          <Link to={ROUTES.DETAILSEMPTY + nToString(item.id)}>
            <u>Ver detalles</u>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default MiniaturaItem;
